/* Frinta 2026 — storefront behaviours: menu drawer, size-guide drawer, locale select, collection sort,
   cart-drawer upsells. Dawn's cart-drawer.js / cart.js handle the cart itself. */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- simple drawer (menu, size guide) with focus handling ---------- */
  function makeDrawer(root, panelSel) {
    if (!root) return null;
    const panel = $(panelSel, root);
    let opener = null;
    const focusables = () => $$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])', panel);
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables(); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open(by) {
      opener = by || document.activeElement;
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', onKey);
      setTimeout(() => { const f = focusables(); (f[0] || panel).focus(); }, 60);
    }
    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
      if (!$('.fr-menu.is-open, .fr-sg.is-open, cart-drawer.active')) document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKey);
      if (opener && opener.focus) opener.focus();
    }
    return { open, close, root };
  }

  document.addEventListener('DOMContentLoaded', () => {
    const menu = makeDrawer($('#FrintaMenu'), '.fr-menu__panel');
    const sg = makeDrawer($('#FrintaSizeGuide'), '.fr-sg__panel');

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-menu-open], [data-menu-close], [data-size-guide], [data-sg-close]');
      if (!t) return;
      if (t.hasAttribute('data-menu-open')) { e.preventDefault(); menu && menu.open(t); return; }
      if (t.hasAttribute('data-menu-close')) { menu && menu.close(); }
      if (t.hasAttribute('data-size-guide')) { if (sg) { e.preventDefault(); sg.open(t); } return; }
      if (t.hasAttribute('data-sg-close')) { sg && sg.close(); }
    });

    /* country / currency select in the menu drawer: submit Shopify's localization form on change */
    // country change: also send the new market's default language (first of country.available_languages), else keep the current one
    $$('[data-locale-select]').forEach((sel) => sel.addEventListener('change', () => {
      const f = sel.closest('form'); if (!f) return;
      const lang = $('[data-locale-lang]', f), opt = sel.options[sel.selectedIndex];
      if (lang && opt && opt.dataset.lang) lang.value = opt.dataset.lang;
      f.submit();
    }));

    /* collection: "Filtrer et trier" is a native sort select */
    $$('[data-sort-select]').forEach((sel) => sel.addEventListener('change', () => {
      const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
    }));

    /* cart drawer upsells: add the variant of the size she picked (the drawer preselects her cart size, sold-out sizes are disabled).
       Variant ids come from the drawer (Liquid), so this works in every language (18 Oct 2026; was: matched French option names) */
    document.addEventListener('change', (e) => { if (e.target.matches('[data-upsell-size]')) e.target.classList.remove('is-missing'); });
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      const sel = btn.closest('.fr-up').querySelector('[data-upsell-size]');
      if (sel && !sel.value) { sel.classList.add('is-missing'); sel.focus(); return; }
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.frintaAddItems([{ id: Number(sel ? sel.value : btn.dataset.variant), quantity: 1 }]);
        const b2 = document.querySelector(`[data-upsell-add][data-variant="${btn.dataset.variant}"]`) || btn; // the patched drawer keeps the same button
        b2.classList.add('is-added'); setTimeout(() => b2.classList.remove('is-added'), 1600);
      } catch (err) {
        console.error(err);
        const err2 = document.getElementById('CartDrawer-CartErrors'); if (err2) err2.textContent = String(err.message || err);
      } finally { btn.removeAttribute('aria-busy'); }
    });
  });

  /* Keep internal links in her language/market: header, footer, chips and page texts hold plain '/pages/…' links (theme settings,
     translations), which would drop an /en-gb or /de-de visitor on the French store in euros (18 Oct 2026). */
  const localise = (root) => {
    const R = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    if (!R) return;
    (root || document).querySelectorAll('a[href^="/"]').forEach((a) => {
      const h = a.getAttribute('href');
      if (h.startsWith('//') || h.startsWith(R + '/') || h === R) return;
      if (/^\/[a-z]{2}(-[a-z0-9]{2,4})?(\/|$|\?|#)/i.test(h)) return; // already another language/market (switchers)
      if (/^\/(cdn|apps|checkouts?|services|account|s\/)/.test(h)) return;
      a.setAttribute('href', R + h);
    });
  };
  document.addEventListener('DOMContentLoaded', () => localise());
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) localise(n); }))).observe(document.documentElement, { childList: true, subtree: true });

  /* Free gift briefs: one per 3 tanks, kept in step with the tanks wherever she changes them (drawer +/−, cart page, add-ons):
     reaching 3 tanks adds the briefs in her tank size (Nude), going below takes the extra ones out, so a cart can't keep
     0,00 € briefs without the tanks (18 Oct 2026). */
  let giftBusy = false;
  const syncGift = async () => {
    const R = window.frGiftRule; if (!R || !R.gift || !R.tank || giftBusy) return;
    giftBusy = true;
    try {
      const cart = await (await fetch(window.routes.cart_url + '.js')).json();
      const tanks = cart.items.filter((i) => i.product_id === R.tank).reduce((a, i) => a + i.quantity, 0);
      let allowed = Math.floor(tanks / (R.per || 3));
      const lines = cart.items.filter((i) => i.product_id === R.gift);
      const have = lines.reduce((a, i) => a + i.quantity, 0);
      if (have === allowed) return;
      const drawer = document.querySelector('cart-drawer');
      let url = window.routes.cart_update_url, body;
      if (have > allowed) {
        const updates = {};
        lines.forEach((i) => { const q = Math.min(i.quantity, allowed); allowed -= q; updates[i.key] = q; });
        body = { updates };
      } else {
        const t = cart.items.find((i) => i.product_id === R.tank);
        const size = t && (t.options_with_values || []).map((o) => o.value).find((v) => R.v && R.v[v]);
        const id = (R.v && (R.v[size] || Object.values(R.v)[0])) || 0;
        if (!id) return;
        url = window.routes.cart_add_url; body = { items: [{ id, quantity: allowed - have }] };
      }
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map((x) => x.id).join(','); body.sections_url = window.location.pathname; }
      const json = await (await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })).json();
      if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
      if (drawer && json.sections) window.frintaRenderDrawer(json);
    } catch (e) { console.error(e); } finally { giftBusy = false; }
  };
  window.frintaSyncGift = syncGift;
  document.addEventListener('DOMContentLoaded', () => {
    syncGift();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'frinta-gift') setTimeout(syncGift, 50); });
  });

  /* Smooth drawer update (18 Oct 2026): when the drawer is open, patch only what changed (same photos stay, her scroll stays,
     menus keep their choice) instead of Dawn's full re-render; new lines get a short highlight. Closed drawer: Dawn as before. */
  const keyOf = (n) => (n.nodeType === 1 && n.dataset ? n.dataset.k || '' : ''); // cart lines only: ids shift with the line number, and Dawn's +/− keep a reference to their input
  const same = (a, b) => a.nodeType === b.nodeType && a.nodeName === b.nodeName && keyOf(a) === keyOf(b);
  const morph = (a, b) => {
    if (a.nodeType !== 1) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
    [...a.attributes].forEach((at) => { if (!b.hasAttribute(at.name)) a.removeAttribute(at.name); });
    [...b.attributes].forEach((at) => { if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value); });
    if (a.tagName === 'INPUT' && a.type !== 'hidden' && document.activeElement !== a) a.value = b.getAttribute('value') || '';
    const bc = [...b.childNodes];
    bc.forEach((nb, i) => {
      const na = a.childNodes[i];
      if (na && same(na, nb)) { morph(na, nb); return; }
      const k = keyOf(nb), m = k && [...a.childNodes].slice(i).find((x) => keyOf(x) === k && same(x, nb));
      if (m) { a.insertBefore(m, na || null); morph(m, nb); } else a.insertBefore(document.importNode(nb, true), na || null);
    });
    while (a.childNodes.length > bc.length) a.removeChild(a.lastChild);
  };
  window.frintaRenderDrawer = function (json) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!drawer.classList.contains('active') || !json.sections || !json.sections['cart-drawer']) { drawer.renderContents(json); return; }
    const live = document.getElementById('CartDrawer');
    const fresh = new DOMParser().parseFromString(json.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
    if (!live || !fresh) { drawer.renderContents(json); return; }
    const before = new Set([...live.querySelectorAll('[data-k]')].map((x) => x.dataset.k));
    const panel = live.querySelector('.fr-cart__panel'), top = panel ? panel.scrollTop : 0;
    morph(live, fresh);
    if (panel) panel.scrollTop = top;
    const empty = !live.querySelector('[data-k]');
    drawer.classList.toggle('is-empty', empty);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && json.sections['cart-icon-bubble']) {
      const nb = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (nb) bubble.innerHTML = nb.innerHTML;
    }
    live.querySelectorAll('[data-k]').forEach((x) => { if (!before.has(x.dataset.k)) { x.classList.remove('fr-item--new'); void x.offsetWidth; x.classList.add('fr-item--new'); } });
  };

  /* Add items with /cart/add.js and let Dawn's cart-drawer render + open itself (sections API). */
  window.frintaAddItems = async function (items) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }
    const r = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
    const json = await r.json();
    if (json.status || json.errors) throw new Error(json.description || json.message || json.errors || 'add failed');
    if (drawer) {
      drawer.classList.remove('is-empty');
      window.frintaRenderDrawer(json);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', origin: 'frinta', cartData: json }); // 'cart-items': Dawn's drawer would otherwise re-fetch and replace itself a second time
    } else {
      window.location = window.routes.cart_url;
    }
    return json;
  };
})();

/* Size finder (size-guide drawer + page): bust in cm, or height + weight. Mapping copied from the sales page. */
(function () {
  const SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  const FR = { S: '34–36', M: '38', L: '40', XL: '42–44', '2XL': '46–48', '3XL': '50', '4XL': '52+' };
  const US = { S: '0–2', M: '4–6', L: '8–10', XL: '12–16', '2XL': '18', '3XL': '20–22', '4XL': '24+' }; // US/CA visitors, as on the sales page
  const byBust = (c) => (c <= 85 ? 'S' : c <= 89 ? 'M' : c <= 94 ? 'L' : c <= 105 ? 'XL' : c <= 112 ? '2XL' : c <= 121 ? '3XL' : '4XL');
  const byBmi = (h, w) => { const b = w / Math.pow(h / 100, 2); return b < 20 ? 'S' : b < 22.5 ? 'M' : b < 25 ? 'L' : b < 28.5 ? 'XL' : b < 32 ? '2XL' : b < 36 ? '3XL' : '4XL'; };
  document.addEventListener('click', (e) => {
    const go = e.target.closest('[data-sf-go]'); if (!go) return;
    const box = go.closest('[data-sizefinder]');
    const h = Number(box.querySelector('[data-sf-height]').value), w = Number(box.querySelector('[data-sf-weight]').value), c = Number(box.querySelector('[data-sf-bust]').value);
    let size = c >= 60 ? byBust(c) : (h && w >= 35 ? byBmi(h, w) : '');
    if (c >= 60 && h && w >= 35) { const s2 = byBmi(h, w); if (SIZES.indexOf(s2) > SIZES.indexOf(size) + 1) size = SIZES[SIZES.indexOf(size) + 1]; }
    box.querySelector('[data-sf-err]').hidden = !!size;
    const res = box.querySelector('[data-sf-res]'); res.hidden = !size;
    if (size) {
      box.querySelector('[data-sf-size]').textContent = size;
      const fr = box.querySelector('[data-sf-fr]'), us = box.dataset.geo === 'US' || box.dataset.geo === 'CA';
      if (fr) fr.textContent = ((us ? fr.dataset.usLabel : fr.dataset.label) || '') + ' ' + (us ? US : FR)[size];
      box.dataset.size = size;
      // fill row 1 of the open pack; the offer-box size sync then fills every row not chosen by hand
      const s0 = document.querySelector('.fr-pack.is-on [data-row="0"] [data-row-size]');
      if (s0 && [...s0.options].some((o) => o.value === size)) { s0.value = size; s0.classList.remove('is-missing'); s0.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
})();
